function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("metadata", {
  id: "metadata2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", {
  id: "defs7"
}, React.createElement("clipPath", {
  id: "clipEmfPath1"
}, React.createElement("path", {
  d: "m0.32013 0.48019h41.937v41.777h-41.937z",
  id: "path4"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.63891 20.07c0-10.727 8.7061-19.433 19.433-19.433 10.747 0 19.433 8.7061 19.433 19.433 0 10.747-8.6866 19.433-19.433 19.433-10.727 0-19.433-8.6866-19.433-19.433z",
  fill: "#fff",
  fillRule: "evenodd",
  id: "path9"
});

var SvgReportAssessee = function SvgReportAssessee(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    id: "svg51",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, React.createElement("path", {
    className: "icon-tertiary",
    transform: "matrix(.97127 0 0 .97127 -.52709 -.52879)",
    d: "m1.2005 21.208c0-11.044 8.9636-20.008 20.008-20.008 11.064 0 20.008 8.9636 20.008 20.008 0 11.064-8.9436 20.008-20.008 20.008-11.044 0-20.008-8.9436-20.008-20.008",
    clipPath: "url(#clipEmfPath1)",
    fill: "none",
    stroke: "#002060",
    strokeMiterlimit: 8,
    id: "path11",
    style: {
      strokeWidth: 0.99972201,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    }
  }), React.createElement("path", {
    style: {
      strokeWidth: 0.999999,
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    },
    id: "path16",
    fillRule: "evenodd",
    fill: "#ffffff",
    d: "m 14.521677,10.034515 c 0,-1.5382157 1.262065,-2.7995487 2.801174,-2.7995487 h 13.143754 c 1.539109,0 2.770429,1.261333 2.770429,2.7995487 v 11.167054 c 0,1.538215 -1.23132,2.76882 -2.770429,2.76882 H 17.322851 c -1.539109,0 -2.801174,-1.230605 -2.801174,-2.76882 z"
  }), React.createElement("path", {
    style: {
      strokeWidth: 0.999999,
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    },
    id: "path50",
    fillRule: "evenodd",
    fill: "#ecaec6",
    d: "m 16.495811,7.4123999 h 13.113418 c 1.569855,0 2.801175,1.2613334 2.801175,2.8303591 v 3.199509 H 13.694637 v -3.199509 c 0,-1.5689437 1.262066,-2.8303591 2.801174,-2.8303591 z",
    className: "icon-primary"
  }), React.createElement("path", {
    className: "icon-secondary",
    d: "m 16.658776,9.6067133 c 0,-0.184583 0.162199,-0.338404 0.356833,-0.338404 h 12.035258 c 0.194634,0 0.324397,0.153821 0.324397,0.338404 v 1.3228787 c 0,0.184583 -0.129763,0.307643 -0.324397,0.307643 H 17.015609 c -0.194634,0 -0.356833,-0.12306 -0.356833,-0.307643 z",
    id: "path52",
    style: {
      fill: "#adb9ca",
      fillRule: "evenodd",
      strokeWidth: 0.999999,
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    }
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    },
    id: "path60",
    strokeMiterlimit: 9.3333,
    d: "m 13.586381,10.431079 c 0,-1.5464063 1.272314,-2.8144224 2.823967,-2.8144224 h 13.25116 c 1.551653,0 2.792976,1.2680161 2.792976,2.8144224 v 11.226773 c 0,1.546407 -1.241323,2.7835 -2.792976,2.7835 h -13.25116 c -1.551653,0 -2.823967,-1.237093 -2.823967,-2.7835 z"
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    },
    id: "path62",
    strokeWidth: 1.19491,
    strokeMiterlimit: 9.3333,
    d: "m 16.466703,7.5871254 h 13.14415 c 1.573637,0 2.807831,1.1841797 2.807831,2.6571606 v 3.00368 H 13.659038 v -3.00368 c 0,-1.4729809 1.265067,-2.6571606 2.807829,-2.6571606 z"
  }), React.createElement("g", {
    transform: "matrix(1,0,0,0.93878806,-0.1163715,1.2844599)",
    id: "g864",
    className: "icon-tertiary",
    style: {
      strokeWidth: 1.03209
    }
  }, React.createElement("path", {
    d: "m 23.380022,16.205236 h 6.525799",
    fill: "none",
    strokeMiterlimit: 8,
    strokeWidth: "0.732867px",
    id: "path32",
    style: {
      strokeWidth: 1.03209,
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    }
  }), React.createElement("path", {
    d: "m 23.380022,20.512107 h 6.525799",
    fill: "none",
    strokeMiterlimit: 8,
    strokeWidth: "0.732867px",
    id: "path38",
    style: {
      strokeWidth: 1.03209,
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    }
  })), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    },
    id: "path64",
    strokeMiterlimit: 10,
    d: "m 16.574943,9.7824679 c 0,-0.18568 0.163647,-0.340417 0.360032,-0.340417 h 12.143073 c 0.196377,0 0.327301,0.154737 0.327301,0.340417 v 1.3307581 c 0,0.18568 -0.130924,0.309472 -0.327301,0.309472 H 16.934975 c -0.196377,0 -0.360032,-0.123785 -0.360032,-0.309472 z"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.13755
    },
    className: "icon-secondary",
    d: "m 12.498599,20.329659 0.106287,0.148292 c 0.998974,1.016911 2.380523,1.631344 3.910877,1.631344 1.551572,0 2.933159,-0.614373 3.932095,-1.631344 l 0.106287,-0.148292 0.807686,0.169473 c 2.359304,0.995718 3.995869,3.326074 3.995869,6.016595 v 5.487007 l -2.848165,1.03808 c -1.955439,0.444899 -3.953433,0.677928 -5.993866,0.677928 -2.019212,0 -4.017207,-0.233041 -5.972526,-0.677928 l -2.8693833,-1.03808 v -5.487007 c 0,-2.690521 1.6579028,-5.020925 4.0172073,-6.016595 z",
    fill: "#adb9ca",
    fillRule: "evenodd",
    id: "path13-3-0-6"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.13755
    },
    className: "icon-tertiary",
    d: "m 12.498599,20.329659 0.106287,0.148292 c 0.998974,1.016911 2.380523,1.631344 3.910877,1.631344 1.551572,0 2.933159,-0.614373 3.932095,-1.631344 l 0.106287,-0.148292 0.807686,0.169473 c 2.359304,0.995718 3.995869,3.326074 3.995869,6.016595 v 5.487007 l -2.848165,1.03808 c -1.955439,0.444899 -3.953433,0.677928 -5.993866,0.677928 -2.019212,0 -4.017207,-0.233041 -5.972526,-0.677928 l -2.8693833,-1.03808 v -5.487007 c 0,-2.690521 1.6579028,-5.020925 4.0172073,-6.016595 z",
    fill: "none",
    stroke: "#002060",
    strokeMiterlimit: 8,
    id: "path15-0-3-1"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.13755
    },
    className: "icon-secondary",
    d: "m 11.074457,17.193749 c 0,-3.029586 2.444299,-5.508175 5.441231,-5.508175 3.018152,0 5.441232,2.478709 5.441232,5.508175 0,3.050756 -2.42308,5.508175 -5.441232,5.508175 -2.996932,0 -5.441231,-2.457539 -5.441231,-5.508175 z",
    fill: "#adb9ca",
    fillRule: "evenodd",
    id: "path17-2-3-8"
  }), React.createElement("path", {
    id: "path21-8-4-3",
    strokeMiterlimit: 8,
    stroke: "#002060",
    fill: "none",
    d: "m 11.073986,17.19327 c 0,-3.029586 2.444297,-5.508175 5.44123,-5.508175 3.018151,0 5.441231,2.478709 5.441231,5.508175 0,3.050755 -2.42308,5.508176 -5.441231,5.508176 -2.996933,0 -5.44123,-2.45754 -5.44123,-5.508176",
    className: "icon-tertiary",
    style: {
      strokeWidth: 1.13755
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReportAssessee, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report-assessee.ca89e3e8.svg";
export { ForwardRef as ReactComponent };